<template>
  <div class="box">
    <div class="clearfix">
      <el-button @click="$router.push('/prepareLessons/newLesson')"
        >新增备课</el-button
      >

      <el-button style="margin-left: 30px" @click="handlebatchshare"
        >批量共享</el-button
      >
      <el-dialog
        title="共享类型"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <el-radio v-model="radio" label="1">仅共享</el-radio>
        <el-radio v-model="radio" label="2">协同备课</el-radio>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handlesharedia">确 定</el-button>
        </span>
      </el-dialog>
      <el-button style="margin-left: 30px" @click="handlebatchDel"
        >批量删除</el-button
      >
      <!-- 查看协同备课 -->
      <el-button class="fr" @click="handleShareclick">{{
        Collesson
      }}</el-button>
    </div>

    <div style="padding: 20px 0">
      共 {{ count }} 条数据
      <i
        class="el-icon-warning-outline"
        style="color: #e6b210; margin-left: 20px"
      ></i>
      已选择{{ multipleSelection.length }}项
    </div>
    <el-table
      :header-cell-style="{ background: '#f5f9ff', color: '#606266' }"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="序号" width="120" type="index">
        <!-- <template slot-scope="scope">{{ scope.row.lesson_id }}</template> -->
      </el-table-column>
      <el-table-column prop="lesson_name" label="备课名称" width="220">
      </el-table-column>
      <el-table-column label="所属年级" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.grade_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="附件" width="300">
        <template slot-scope="scope">
          <div
            v-for="(item, index) in JSON.parse(scope.row.content)"
            :key="index"
          >
            {{ item.file_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="180">
        <template slot-scope="scope">
          {{
            new Date(parseInt(scope.row.create_time) * 1000)
              .toLocaleString()
              .replace(/:\d{1,2}$/, " ")
          }}
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="handleDownload(scope.$index, scope.row)"
            v-if="Collesson != '查看协同备课'"
            >下载</el-button
          >
          <el-button
            type="text"
            @click="handleShare(scope.$index, scope.row)"
            v-if="Collesson == '查看协同备课'"
            >共享</el-button
          >
          <el-button type="text" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button type="text" @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage3"
        :page-size="6"
        prev-text="上一页"
        next-text="下一页"
        layout="prev, pager, next, jumper"
        :total="count"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import URL from "@/api/index.js";
import axios from "axios";
import { rand } from "../../api/http";
import VueEvent from "@/model/VueEvent";
export default {
  inject: ["reload"],
  data() {
    return {
      radio: "2",
      count: 0,
      page: 1,
      // content: [],
      tableData: [],
      multipleSelection: [],
      currentPage3: 1,
      time: "",
      dialogVisible: false,
      share_type: "",
      data_sharetype: "",
      lesson_id: null,
      Collesson: "查看协同备课",
      keyword: 0,
      grade: 0,
      subject: 0,
      start_time: 0,
      end_time: 0,
      shareone: null,
      allgrade: [],
      aa: [],
      sharerow: {},
      fmttype: [
        { fmttype_id: "0", fmttype_name: "全部" },
        { fmttype_id: "11", fmttype_name: "文档" },
        { fmttype_id: "22", fmttype_name: "图片" },
        { fmttype_id: "33", fmttype_name: "音频" },
        { fmttype_id: "44", fmttype_name: "视频" },
        { fmttype_id: "55", fmttype_name: "幻灯片" },
        { fmttype_id: "66", fmttype_name: "其他" },
      ],
      restype: [
        { restype_id: "0", restype_name: "全部" },
        { restype_id: "0101", restype_name: "教案" },
        { restype_id: "0102", restype_name: "课件" },
        { restype_id: "0301", restype_name: "同步课程" },
        { restype_id: "0103", restype_name: "学案" },
        { restype_id: "0104", restype_name: "素材" },
        { restype_id: "0203", restype_name: "习题" },
        { restype_id: "0105", restype_name: "电子课本" },
      ],
    };
  },
  components: {},
  mounted() {
    this.getallgrade();
    this.handlelist();
    VueEvent.$on("title", (res) => {
      this.page = 1;
      this.currentPage3 = 1;
      this.keyword = res;
      if (this.Collesson == "查看全部") {
        this.handleSharelist();
      } else {
        this.handlelist();
      }
    });
    VueEvent.$on("grade", (res) => {
      this.page = 1;
      this.currentPage3 = 1;
      this.grade = res;
      if (this.Collesson == "查看全部") {
        this.handleSharelist();
      } else {
        this.handlelist();
      }
    });
    VueEvent.$on("subject", (res) => {
      this.page = 1;
      this.currentPage3 = 1;
      this.subject = res;
      if (this.Collesson == "查看全部") {
        this.handleSharelist();
      } else {
        this.handlelist();
      }
    });
    // 时间筛选
    VueEvent.$on("time", (res) => {
      this.page = 1;
      this.currentPage3 = 1;
      if (res == 0) {
        this.start_time = 0;
        this.end_time = 0;
      } else {
        // var a = Math.round(new Date(res[0]).getTime() / 1000).toString();
        // var b = Math.round(new Date(res[1]).getTime() / 1000).toString();
        this.start_time = Math.round(
          new Date(res[0]).getTime() / 1000
        ).toString();
        this.end_time = Math.round(
          new Date(res[1]).getTime() / 1000
        ).toString();
      }
      // 备课数据上报
      var hhh = JSON.parse(localStorage.getItem("loginInfo"));
      this.getRjw(hhh);
      if (this.Collesson == "查看全部") {
        this.handleSharelist();
      } else {
        this.handlelist();
      }
    });
  },
  methods: {
    // 搜索数据上报
    getRjw(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入我的备课
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "preparelessons_search",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了我的备课的搜索功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("prepare_traceid")),
            searchbegintime: this.start_time ? this.start_time : "",
            searchendtime: this.end_time ? this.end_time : "",
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //获取年级
    getallgrade() {
      this.$post(URL.allgrade).then((res) => {
        this.allgrade = res.result.grade_list;
      });
    },
    // 共享弹框
    handleClose(done) {
      done();
    },
    handlesharedia() {
      if (this.radio == 1) {
        if (
          (localStorage.getItem("le_type") == 2 &&
            localStorage.getItem("share_type") == "") ||
          (localStorage.getItem("le_type") == 2 &&
            localStorage.getItem("share_type") == 0) ||
          (localStorage.getItem("le_type") == 3 &&
            localStorage.getItem("share_type") == 0)
        ) {
          this.$message({
            message: "已经是仅共享的状态",
          });
          this.dialogVisible = false;
          return false;
        }
        this.share_type = "0";
        this.data_sharetype = "仅共享";
      } else {
        this.share_type = "1";
        this.data_sharetype = "协同备课";
      }
      this.dialogVisible = false;
      this.getShare();
    },
    // 批量共享
    handlebatchshare() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请选择至少一条数据",
        });
        return false;
      }
      this.dialogVisible = true;
    },
    // 批量删除数据上报
    getRjwBatchDel(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入我的备课
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "preparelessons_batchdelete",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了我的备课的批量删除功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("prepare_traceid")),
            deleteprepare_list: this.aa,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    // 批量删除
    handlebatchDel() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请选择至少一条数据",
        });
        return false;
      }
      // 数据上报
      this.aa = [];
      this.multipleSelection.forEach((item) => {
        var dd = {};
        var content = JSON.parse(item.content);
        dd.prepare_name = item.lesson_name;
        dd.grade_name = item.grade_name;
        dd.grade_id = item.grade_id;
        dd.file_name = content[0].file_name;
        dd.file_id = content[0].file_id;
        dd.create_time = item.create_time;
        this.fmttype.forEach((item1) => {
          if (content[0].file_format == item1.fmttype_id) {
            dd.file_format = item1.fmttype_name;
          }
        });
        this.restype.forEach((item2) => {
          if (content[0].file_type == item2.restype_id) {
            dd.file_type = item2.restype_name;
          }
        });
        this.aa.push(dd);
      });
      // 批量删除
      this.getRjwBatchDel(JSON.parse(localStorage.getItem("loginInfo")));

      var a = this.multipleSelection.map((item) => {
        return item.lesson_id;
      });
      var s = a.join(",");
      var data = {
        token: JSON.parse(localStorage.getItem("loginInfo")).token,
        ids: s,
      };
      this.$post(URL.getDel, data).then((res) => {
        if (this.Collesson == "查看全部") {
          this.handleSharelist();
        } else {
          this.handlelist();
        }
        this.$message({
          type: "success",
          message: "删除成功",
        });
      });
    },

    // 列表切换按钮
    handleShareclick() {
      // 默认第一页
      this.page = 1;
      this.currentPage3 = 1;
      if (this.Collesson == "查看全部") {
        this.Collesson = "查看协同备课";
        this.handlelist();
      } else {
        this.Collesson = "查看全部";
        this.handleSharelist();
      }
    },
    // 协同备课列表
    handleSharelist() {
      var data = {
        share_type: "1",
        page: this.page,
        num: 6,
        keyword: this.keyword,
        grade_id: this.grade,
        subject_id: this.subject,
        start_time: this.start_time,
        end_time: this.end_time,
        school_id: JSON.parse(localStorage.getItem("loginInfo")).school_id,
        token: JSON.parse(localStorage.getItem("loginInfo")).token,
      };
      this.$post(URL.getSharelist, data).then((res) => {
        res.result.list.forEach((item) => {
          this.allgrade.forEach((item1) => {
            if (item.grade_id == item1.gid) {
              item.grade_name = item1.grade_name;
            }
          });
        });
        this.tableData = res.result.list;
        this.count = res.result.count;
      });
    },

    //全部 备课列表
    handlelist() {
      var that = this;
      var data = {
        token: JSON.parse(localStorage.getItem("loginInfo")).token,
        range: "my",
        page: this.page,
        num: 6,
        keyword: this.keyword,
        grade_id: this.grade,
        subject_id: this.subject,
        start_time: this.start_time,
        end_time: this.end_time,
      };
      this.$post(URL.getLessonList, data).then((res) => {
        that.count = res.result.count;
        res.result.list.forEach((item) => {
          that.allgrade.forEach((item1) => {
            if (item.grade_id == item1.gid) {
              item.grade_name = item1.grade_name;
            }
          });
        });
        that.tableData = res.result.list;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 批量共享数据上报
    getRecordRjwbatch(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入我的备课
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "preparelessons_batchshared",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了我的备课的批量共享功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("prepare_traceid")),
            share_type: this.data_sharetype,
            shareprepare_list: this.aa,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    // 单个共享数据上报
    getRecordRjw(hh) {
      var content = JSON.parse(this.sharerow.content);
      // console.log(this.sharerow.content);
      this.fmttype.forEach((item2) => {
        if (content[0].file_format == item2.fmttype_id) {
          content[0].file_format = item2.fmttype_name;
        }
      });
      this.restype.forEach((item3) => {
        if (content[0].file_type == item3.restype_id) {
          content[0].file_type = item3.restype_name;
        }
      });

      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入我的备课
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "preparelessons_shared",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了我的备课的共享功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("prepare_traceid")),
            prepare_name: this.sharerow.lesson_name,
            grade_name: this.sharerow.grade_name,
            grade_id: this.sharerow.grade_id,
            file_type: content[0].file_type,
            file_format: content[0].file_format,
            file_name: JSON.parse(this.sharerow.content)[0].file_name,
            file_id: JSON.parse(this.sharerow.content)[0].file_id,
            create_time: this.sharerow.create_time,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    // 共享功能
    getShare() {
      var lessonid;
      if (this.shareone == 1) {
        lessonid = this.lesson_id;
        // 共享 数据上报
        this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")));
      } else {
        var a = this.multipleSelection.map((item) => {
          return item.lesson_id;
        });
        var s = a.join(",");
        lessonid = s;
        // 批量共享 数据上报
        this.aa = [];
        this.multipleSelection.forEach((item) => {
          var dd = {};
          var content = JSON.parse(item.content);
          dd.prepare_name = item.lesson_name;
          dd.grade_name = item.grade_name;
          dd.grade_id = item.grade_id;
          dd.file_name = content[0].file_name;
          dd.file_id = content[0].file_id;
          dd.create_time = item.create_time;
          this.fmttype.forEach((item1) => {
            if (content[0].file_format == item1.fmttype_id) {
              dd.file_format = item1.fmttype_name;
            }
          });
          this.restype.forEach((item2) => {
            if (content[0].file_type == item2.restype_id) {
              dd.file_type = item2.restype_name;
            }
          });
          this.aa.push(dd);
        });
        // 批量共享
        this.getRecordRjwbatch(JSON.parse(localStorage.getItem("loginInfo")));
      }
      var data = {
        token: JSON.parse(localStorage.getItem("loginInfo")).token,
        ids: lessonid,
        le_type: "2",
        share_type: this.share_type,
      };
      this.$post(URL.getShare, data).then((res) => {
        // this.reload();
        if (res.state == 0) {
          this.$message({
            type: "success",
            message: "共享成功",
          });
        } else {
          this.$message({
            message: "共享失败",
          });
        }
        // 重新加载列表
        if (this.Collesson == "查看全部") {
          this.handleSharelist();
        } else {
          this.handlelist();
        }
      });
      this.shareone = null;
    },
    handleShare(index, row) {
      this.shareone = 1;
      localStorage.setItem("le_type", row.le_type);
      localStorage.setItem("share_type", row.share_type);
      this.sharerow = row;
      // console.log(row);
      if (row.share_type == "1" && row.le_type == "2") {
        this.dialogVisible = false;
        this.$message({
          message: "已共享为协同备课",
        });
      } else {
        this.dialogVisible = true;
      }
      this.lesson_id = row.lesson_id;
    },

    downloadFile(file, fileName) {
      const link = document.createElement("a");
      link.href = file;
      link.download = fileName || Date.now().toString(36);
      document.body.appendChild(link);
      const evt = document.createEvent("MouseEvents");
      evt.initEvent("click", false, false);
      link.dispatchEvent(evt);
      document.body.removeChild(link);
    },
    // 下载数据上报
    getRjwDownload(hh, row) {
      var content = JSON.parse(row.content);
      this.fmttype.forEach((item2) => {
        if (content[0].file_format == item2.fmttype_id) {
          content[0].file_format = item2.fmttype_name;
        }
      });
      this.restype.forEach((item3) => {
        if (content[0].file_type == item3.restype_id) {
          content[0].file_type = item3.restype_name;
        }
      });

      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入我的备课
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "preparelessons_startpldown",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了我的备课的下载功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("prepare_traceid")),
            prepare_name: row.lesson_name,
            grade_name: row.grade_name,
            grade_id: row.grade_id,
            file_type: content[0].file_type,
            file_format: content[0].file_format,
            file_name: content[0].file_name,
            file_id: content[0].file_id,
            create_time: row.create_time,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },

    // 下载
    handleDownload(index, row) {
      // console.log(row);
      var a = JSON.parse(row.content);
      a.forEach((item) => {
        this.$get(URL.fileDown, item.file_id).then((res) => {});
        window.location.href = item.download_url;
      });
      // 数据上报
      this.getRjwDownload(JSON.parse(localStorage.getItem("loginInfo")), row);
      // var params = {
      //   fileid: a[0].file_id,
      // };
      // this.$get(URL.fileDown, params).then((res) => {});

      // window.location.href = a[0].download_url;
    },
    handleEdit(index, row) {
      // console.log(row.lesson_id);
      var data = {
        token: JSON.parse(localStorage.getItem("loginInfo")).token,
        lesson_id: row.lesson_id,
      };
      this.$post(URL.getLessondetails, data).then((res) => {
        VueEvent.$emit("edit", res.result);
        localStorage.setItem("edit", JSON.stringify(res.result));
        this.$router.push("/prepareLessons/collaborativeLesson");
      });
    },
    // 单个删除
    handleDelete(index, row) {
      // console.log(index, row);
      this.getRjwDel(JSON.parse(localStorage.getItem("loginInfo")), row);
      var data = {
        token: JSON.parse(localStorage.getItem("loginInfo")).token,
        ids: row.lesson_id,
      };
      this.$post(URL.getDel, data).then((res) => {
        if (this.Collesson == "查看全部") {
          this.handleSharelist();
        } else {
          this.handlelist();
        }
        this.$message({
          type: "success",
          message: "删除成功",
        });
      });
    },
    // 单个删除数据上报
    getRjwDel(hh, row) {
      var content = JSON.parse(row.content);
      this.fmttype.forEach((item2) => {
        if (content[0].file_format == item2.fmttype_id) {
          content[0].file_format = item2.fmttype_name;
        }
      });
      this.restype.forEach((item3) => {
        if (content[0].file_type == item3.restype_id) {
          content[0].file_type = item3.restype_name;
        }
      });

      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入我的备课
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "preparelessons_delete",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了我的备课的删除功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("prepare_traceid")),
            prepare_name: row.lesson_name,
            grade_name: row.grade_name,
            grade_id: row.grade_id,
            file_type: content[0].file_type,
            file_format: content[0].file_format,
            file_name: JSON.parse(row.content)[0].file_name,
            file_id: JSON.parse(row.content)[0].file_id,
            create_time: row.create_time,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      if (this.Collesson == "查看全部") {
        this.handleSharelist();
      } else {
        this.handlelist();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: #fff;
  padding: 30px 20px;
  margin-top: 15px;
  .block {
    margin-top: 20px;
    text-align: center;
  }

  .el-table/deep/.el-table__body-wrapper {
    min-height: 400px !important;
  }
}
</style>
